import { LoadState } from "../../constants/enums";

export interface IChatbotContact {
  recipient_number: string;
  recipient_name: string;
  content: ILastMessage[];
  create_ts?: string | null;
  insert_ts?: string | null;
  timestamp?: string | null;
  unread_message?: number;
  message_status?: string;
}

export interface IActionEvent {
  conversation_sentiment_unique_id: number;
  conversation_sentiment_uuid: string;
  conversation_id: string;
  sentiment: string;
  message: string;
  status: string;
  company_outlet_uuid: string;
  created_by_uuid: string | null;
  created_by_name: string | null;
  modified_by_uuid: string | null;
  modified_by_name: string | null;
  create_ts: string;
  insert_ts: string;
}

export interface ILastMessage {
  [key: string]: any;
}

export interface IChatbotState {
  contactList: {
    list: IChatbotContact[];
    loading: boolean;
    error: string | null;
    totalRecords: number;
    hasMoreRecords: boolean;
  };

  actionEventList: {
    list: IActionEvent[];
    loading: LoadState;
    error: string | null;
    totalRecords: number;
    hasMoreRecords: boolean;
  };
}

export const initialChatbotState: IChatbotState = {
  contactList: {
    list: [],
    loading: false,
    error: null,
    totalRecords: 0,
    hasMoreRecords: false,
  },
  actionEventList: {
    list: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
    hasMoreRecords: false,
  },
};

export const defaultActionEvent: IActionEvent = {
  conversation_sentiment_unique_id: 0,
  conversation_sentiment_uuid: "",
  conversation_id: "",
  sentiment: "",
  message: "",
  status: "",
  company_outlet_uuid: "",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: "",
  insert_ts: "",
};
